import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { API_ENDPOINTS } from '@core/constants/api-endpoints';
import { Session } from '@core/service/session/session';
import { Toast } from '@shared/services/toast/toast';
import { Auth } from 'app/features/auth/services/auth/auth';
import { environment } from 'environments/environment';
import { catchError, switchMap, throwError } from 'rxjs';

const PUBLIC_URLS: string[] = [
  // API_ENDPOINTS.AUTH.DROPDOWNS,
  // API_ENDPOINTS.AUTH.SIGNUP,
  // API_ENDPOINTS.AUTH.GOOGLE_CALLBACK,
  // API_ENDPOINTS.AUTH.FORGOT_PASSWORD,
  // API_ENDPOINTS.AUTH.LOGIN,

];



export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  // const session = inject(Session);
  // const token = session.getToken();
  // const authService = inject(Auth);

  // // Skip adding token for public or excluded URLs
  // const isPublic = PUBLIC_URLS.some(url => req.url.includes(url));
  // const refreshToken = session.getRefreshToken();
  // if (isPublic) {
  //   return next(req);
  // }




  // // If no token → send request as-is
  // if (!token) {
  //   return next(req);
  // }

  // // Clone request with Authorization header
  // const authReq = req.clone({
  //   setHeaders: {
  //     Authorization: `Bearer ${token}`
  //   }
  // });

  // return next(authReq).pipe(
  //   catchError((error: HttpErrorResponse) => {
  //     // If 401 and refresh token exists
  //     if (error.status === 401 && refreshToken) {
  //       // Call refresh token API
  //       return authService.refreshToken(refreshToken).pipe(
  //         switchMap((newSession) => {
  //           // Update session with new tokens
  //           session.setSession(newSession);

  //           // Retry original request with new access token
  //           const retryReq = req.clone({
  //             setHeaders: { Authorization: `Bearer ${newSession.access_token}` },
  //           });
  //           return next(retryReq);
  //         }),
  //         catchError((refreshError) => {
  //           // Refresh failed → clear session
  //           session.clearSession();
  //           return throwError(() => refreshError);
  //         })
  //       );
  //     }
  //     return throwError(() => error);
  //   })
  // );

  // if (environment.site !== 'admin') {
  //   return next(req); // portal → pass through as-is
  // }

  const session = inject(Session);
  const authService = inject(Auth);
  const toaster = inject(Toast);

  const token = session.getToken();
  const refreshToken = session.getRefreshToken();
  const isPublic = PUBLIC_URLS.some(url => req.url.includes(url));

  // Skip public endpoints
  if (isPublic) {
    return next(req);
  }

  // Clone request with Authorization header if token exists
  const authReq = token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      // Handle 401 Unauthorized with refresh token
      if (error.status === 401 && refreshToken) {
        return authService.refreshToken(refreshToken).pipe(
          switchMap((newSession) => {
            session.setSession(newSession); // Update session with new tokens

            // Retry original request with refreshed token
            const retryReq = req.clone({ setHeaders: { Authorization: `Bearer ${newSession.access_token}` } });
            return next(retryReq);
          }),
          catchError((refreshError: HttpErrorResponse) => {
            // Refresh failed → clear session and show toast
            session.clearSession();
            toaster.error('Session timed out. Please log in again to continue.');
            return throwError(() => refreshError);
          })
        );
      }

      // Handle other HTTP errors
      let errorMessage = 'An unexpected error occurred.';

      if (error.error instanceof ErrorEvent) {
        // Client-side / network error
        errorMessage = `Network Error: ${error.error.message}`;
      } else if (error.error?.message) {
        // Server returned a message
        errorMessage = error.error.message;
      } else {
        // Fallback based on status code
        switch (error.status) {
          case 0:
            errorMessage = 'Unable to connect. Please check your internet connection.';
            break;
          case 400:
            errorMessage = 'Bad Request. Please check your input.';
            break;
          case 403:
            errorMessage = 'Access Denied. You do not have permission.';
            break;
          case 404:
            errorMessage = 'Resource not found.';
            break;
          case 500:
            errorMessage = 'Internal server error. Please try again later.';
            break;
          default:
            errorMessage = `Unexpected error occurred (Code: ${error.status}).`;
        }
      }

      // Show toast
      toaster.error(errorMessage);

      return throwError(() => error);
    })
  );
};
